import React from "react";
import { motion } from "framer-motion";
import { applicationTable } from "../Data";

const BentoniteProductsTable = () => {

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 25,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };

  const staggerRows = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.08,
      },
    },
  };

  return (
    <>
      <section className="table-section container">

        {/* Heading */}
        <motion.h2
          className="section-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
        >
          OUR KEY BENTONITE PRODUCTS RANGE
        </motion.h2>

        <motion.div
          className="table-wrapper"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >

          {/* HEADER */}
          <motion.div
            className="table-header"
            variants={fadeUp}
            style={{
              gridTemplateColumns: `1.8fr repeat(${applicationTable.columns.length - 1}, 1fr)`
            }}
          >
            {applicationTable.columns.map((column, index) => (
              <h3
                key={index}
                className={`card-heading ${
                  column.align === "start" ? "text-start" : ""
                }`}
              >
                {column.label}
              </h3>
            ))}
          </motion.div>

          {/* BODY */}
          <motion.div
            className="table-body"
            variants={staggerRows}
          >

            {applicationTable.data.map((row, rowIndex) => (
              <motion.div
                className="reserve-row row-special"
                key={rowIndex}
                variants={fadeUp}
                style={{
                  gridTemplateColumns: `1.8fr repeat(${applicationTable.columns.length - 1}, 1fr)`
                }}
              >

                {applicationTable.columns.map((column, colIndex) => (
                  <div
                    key={colIndex}
                    className={`table-cell ${
                      column.align === "start" ? "mine-name" : ""
                    }`}
                  >
                    {row[column.key]}
                  </div>
                ))}

              </motion.div>
            ))}

          </motion.div>

        </motion.div>

      </section>
    </>
  );
};

export default BentoniteProductsTable;